import cloneDeep from 'lodash/cloneDeep';
import { useEffect, useState } from 'react';
import { useBeforeunload } from 'react-beforeunload';
import { useTranslation } from 'react-i18next';
import { useStream } from '../../hooks/useStream';
import { RoleEnum, Stage, Widget } from '../../models/Index';
import StateService from '../../services/stateService/StateService';
import UtilService from '../../services/utilService/UtilService';
import Canvas from '../canvas/Canvas';
import GlobalHeader from '../globalHeader/GlobalHeader';
import Header from '../header/Header';
import Navigation from '../navigation/Navigation';
import { useStyles } from './styles';

function Layout() {
    const [t] = useTranslation();
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(true);
    // const [savedStage, setSavedStage] = useState({} as Stage);
    // const [selectedStage, setSelectedStage] = useState({} as Stage);
    const [savedStage, setSavedStage] = useStream(StateService.savedStage$);
    const [selectedStage, setSelectedStage] = useStream(StateService.selectedStage$);
    const [widgets, setWidgets] = useState([] as Widget[]);
    const [currentCustomerId, setCurrentCustomerId] = useState('');
    const [_navState, setNavState] = useState(false);
    const [_currentRoles, setCurrentRoles] = useState([] as RoleEnum[]);

    useEffect(() => {
        const currentCustomerUuid$ = StateService.currentCustomerUuid$.subscribe((currentCustomerUuid) => {
            setCurrentCustomerId(currentCustomerUuid);
        });

        // const savedStage$ = StateService.savedStage$.subscribe((savedStage) => {
        //     setSavedStage(savedStage);
        // });

        // const selectedStage$ = StateService.selectedStage$.subscribe((selectedStage) => {
        //     setSelectedStage(selectedStage);
        // });

        const stageHeader$ = StateService.stageHeader$.subscribe((headers) => {
            setIsLoading(false);
        });

        const widgets$ = StateService.widgets$.subscribe((widgets) => {
            setWidgets(widgets);
        });

        const openNavigation$ = StateService.openNavigation$.subscribe((navState) => {
            setNavState(navState);
        });

        const currentRoles$ = StateService.currentRoles$.subscribe((currentRoles) => {
            setCurrentRoles(currentRoles);
        });
        return () => {
            currentCustomerUuid$.unsubscribe();
            // savedStage$.unsubscribe();
            // selectedStage$.unsubscribe();
            stageHeader$.unsubscribe();
            widgets$.unsubscribe();
            openNavigation$.unsubscribe();
            currentRoles$.unsubscribe();
        };
    }, []);

    // useEffect(() => {
    //     const logZoom = () => {
    //         const zoomLevel = parseFloat(window.devicePixelRatio.toFixed(2));
    //         let zoom = ((window.outerWidth - 10) / window.innerWidth) * 100;

    //         if (zoomLevel * 100 >= 150) {
    //             alert(t('LAYOUT.ZOOM_MESSAGE_ERROR'));
    //         }
    //     };

    //     window.addEventListener('resize', logZoom);

    //     // Log the initial zoom level
    //     logZoom();

    //     // Cleanup event listener on component unmount
    //     return () => {
    //         window.removeEventListener('resize', logZoom);
    //     };
    // }, []);

    useBeforeunload((event) => {
        checkForUnsavedChanges(event);
    });

    function checkForUnsavedChanges(e: any) {
        let tempStage = cloneDeep(selectedStage) as Stage;
        tempStage.publishedGridConfig.layouts.lg = widgets;
        if (UtilService.areUnsavedChangesPresent(tempStage, savedStage)) {
            // return value is needed for popup to pop up
            var confirmationMessage = 'o/';

            (e || window.event).returnValue = confirmationMessage; // Gecko + IE
            return confirmationMessage; // Webkit, Safari, Chrome
        }
    }

    return (
        <div className="layout">
            <GlobalHeader />
            <div className={classes.root} data-testid="layout">
                <Navigation propWidth="240px" />
                <div className={classes.root__layout}>
                    <Header />
                    {!isLoading && (
                        <>
                            {currentCustomerId !== '' ? (
                                <>
                                    <Canvas />
                                </>
                            ) : (
                                <div
                                    data-testid="no-additional-login-data"
                                    style={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <div style={{ paddingTop: '64px' }}>{t('LAYOUT.NO_ADDITIONAL_USER_DATA')}</div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Layout;
